export default __webpack_public_path__ + "static/media/self1.0dd7e7a1.svg";